export default __webpack_public_path__ + "0ad4642a0762259af9628d81fbe09092.png";